import React from "react";
import Grid from "@mui/material/Grid";
import "../../style/components/IngredientList.css";
import { useDispatch, useSelector } from "react-redux";
import { toElement } from "../../utils/utils";
import { useMediaQuery } from "@mui/material";
import { breakpoint } from "../../utils/responsiveUtils";
import Map from "./Map";
import IngredientListMobile from "./IngredientListMobile";
import IngredientListPC from "./IngredientListPC";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import { setChosenLocationEmpty } from "../../api/xoicom.reducer";
import { fetchIngredientDetails } from "../../api/ingredient/ingredient.reduxThunk";
import { useNavigate } from "react-router-dom";

const USE_INGREDIENT_SLUG =
  process.env.REACT_APP_USE_INGREDIENT_SLUG === "TRUE";

function MapText({ mapText }) {
  return (
    <div className="ingredient-card">
      <div className="ingredient-card-text">
        <h1 className="ingredient-text-heading">{mapText.heading}</h1>
        <div className="body-b2 ingredient-text-body">
          {toElement(mapText.bodyText)}
        </div>
      </div>
    </div>
  );
}

//max width 729
function IngredientMobile({
  chosenLocation,
  ingredientPreview,
  showIngredient,
  language,
  ingredientText,
}) {
  const { mapText } = ingredientText;

  return chosenLocation && ingredientPreview?.length > 1 ? (
    <IngredientListMobile
      ingredientPreview={ingredientPreview}
      language={language}
      showIngredient={showIngredient}
      ingredientText={ingredientText}
    />
  ) : (
    <Grid
      container
      spacing={0}
      style={{ padding: "54px 0 350px" }}
      className="mobile-map-grid-container"
    >
      <Grid
        size={{ xs: 12 }}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="mobile-map-container">
          <Map
            ingredientPreview={ingredientPreview}
            accentText={mapText.accentText}
            language={language}
          />
          <MapText mapText={mapText} />
        </div>
      </Grid>
    </Grid>
  );
}

//min width 769
function IngredientPC({
  chosenLocation,
  ingredientText,
  ingredientPreview,
  language,
  showIngredient,
  resetChosenLocation,
}) {
  const { buttonText, mapText } = ingredientText;

  return (
    <Grid container spacing={0} className="mobile-map-grid-container">
      <Grid
        size={{ xs: 6 }}
        style={{ display: "flex", flexDirection: "row", position: "relative" }}
      >
        {chosenLocation && ingredientPreview?.length > 1 && (
          <div className="custom-button-link ingredient-button ingredient-button-underline sticky-back-button">
            <KeyboardArrowLeftRoundedIcon style={{ marginBottom: 2 }} />
            <button
              className="custom-button-link ingredient-button-underline"
              onClick={resetChosenLocation}
            >
              {buttonText.back}
            </button>
          </div>
        )}
        <Map
          ingredientPreview={ingredientPreview}
          accentText={mapText.accentText}
          language={language}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        {chosenLocation && ingredientPreview?.length > 1 ? (
          <IngredientListPC
            ingredientPreview={ingredientPreview}
            language={language}
            size={800}
            showIngredient={showIngredient}
          />
        ) : (
          <MapText mapText={mapText} />
        )}
      </Grid>
    </Grid>
  );
}

function IngredientList({ ingredientText, language }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mobileSm = useMediaQuery(breakpoint.mobileSm);

  const chosenLocation = useSelector(
    (state) => state.reducer.ingredientChosenLocation,
  );
  const ingredientPreview = useSelector(
    (state) => state.reducer.ingredientPreview,
  );

  const showIngredient = (ingredient) => {
    if (USE_INGREDIENT_SLUG) {
      navigate(`/ingredient/${ingredient.slug}`);
    } else {
      const { postID } = ingredient;
      dispatch(fetchIngredientDetails(postID[language]))
        .unwrap()
        .then(() => navigate(`/ingredient/${postID[language]}`));
    }
  };

  return (
    <div className="ingredient-list-container">
      {mobileSm ? (
        <IngredientMobile
          chosenLocation={chosenLocation}
          ingredientPreview={ingredientPreview}
          language={language}
          showIngredient={showIngredient}
          ingredientText={ingredientText}
        />
      ) : (
        <IngredientPC
          chosenLocation={chosenLocation}
          ingredientPreview={ingredientPreview}
          language={language}
          showIngredient={showIngredient}
          ingredientText={ingredientText}
          resetChosenLocation={() => dispatch(setChosenLocationEmpty())}
        />
      )}
    </div>
  );
}

export default IngredientList;
